module.exports = __webpack_public_path__ + "img/2018-09-7.8a9a4e84.jpeg";